import React from "react"

interface Props {
	children: React.ReactNode
	fallback?: React.ReactNode
}

interface State {
	hasError: boolean
	error: Error | null
}

export class ErrorBoundary extends React.Component<Props, State> {
	constructor(props: Props) {
		super(props)
		this.state = { hasError: false, error: null }
	}

	static getDerivedStateFromError(error: Error): State {
		return { hasError: true, error }
	}

	componentDidCatch(error: Error, errorInfo: React.ErrorInfo) {
		console.error("[ErrorBoundary] Caught error:", error, errorInfo)
	}

	render() {
		if (this.state.hasError) {
			if (this.props.fallback) {
				return this.props.fallback
			}
			return (
				<div className="flex flex-col items-center justify-center min-h-[40vh] p-8">
					<div className="text-center max-w-md">
						<div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mx-auto mb-4">
							<svg className="w-6 h-6 text-red-600" fill="none" viewBox="0 0 24 24" stroke="currentColor">
								<path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-2.5L13.732 4c-.77-.833-1.964-.833-2.732 0L4.082 16.5c-.77.833.192 2.5 1.732 2.5z" />
							</svg>
						</div>
						<h2 className="text-lg font-semibold text-gray-900 mb-2">
							Hi ha hagut un error
						</h2>
						<p className="text-sm text-gray-500 mb-4">
							{this.state.error?.message || "Error inesperat"}
						</p>
						<button
							onClick={() => {
								this.setState({ hasError: false, error: null })
								window.location.reload()
							}}
							className="inline-flex items-center px-4 py-2 text-sm font-medium rounded-md bg-gray-900 text-white hover:bg-gray-800 transition-colors"
						>
							Recarregar pàgina
						</button>
					</div>
				</div>
			)
		}

		return this.props.children
	}
}
